import Vue from 'vue'
import Router from 'vue-router' 
import Acitvity from '../view/activity.vue'
import Join from '../view/join.vue'


Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            redirect: '/activity'
        },
        {
            path: '/activity', 
            name:'activity',
            component:Acitvity
        }, 
        {
            path: '/join', 
            name:'join',
            component:Join
        }, 
    ]
})